import Dummy from "components/Dummy";
import P from "components/P";
import CustomIcon from "components/icons/CustomIcon";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import style from "./Footer.module.css";
import { getTokenPayload } from "shared/utils/Utils";
import useLocalStorage from "shared/hooks/useLocalStorage";

function Footer() {
    const { isMobile } = useContext(BrowserDetectContext);
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();

    const desktopFooterList = [
        { title: t("termsOfUse"), url: "termsOfUse", orderNo: "" },
        { title: t("privacyPolicy"), url: "privacyPolicy", orderNo: "" },
        { title: t("shippingPolicy"), url: "shippingPolicy", orderNo: "" }
    ];

    const Tab = ({ index, url, icon, text }) => {
        const [active, setActive] = useState(false);
        const color = active ? "black" : "var(--font-color-disabled)";

        return (
            <div >
                <NavLink to={url} style={({ isActive }) => { setActive(isActive); }} >
                    <Center>
                        <CustomIcon name={icon} color={color} width={20} />
                        <Dummy height={10} />
                        <P size={14} color={color} >{text}</P>
                    </Center>
                </NavLink>
            </div>
        );
    }

    const accordionStyle = {
        '--cui-accordion-bg': "white",
        '--cui-accordion-active-color': "var(--font-color)",
        '--cui-accordion-color': "var(--font-color)",
        '--cui-accordion-active-bg': "var(--user-bg-color)",
        '--cui-accordion-btn-focus-border-color': "none",
        '--cui-accordion-btn-focus-box-shadow': "none",
    }
    const onShippingPolicyClick = () => {
        navigate(`/ws/${id}/homepage/shippingPolicy`)
    }
    const onPrivacyPolicyClick = () => {
        navigate(`/ws/${id}/homepage/privacyPolicy`)
    }
    const onTermsOfUseClick = () => {
        navigate(`/ws/${id}/homepage/termsOfUse`)
    }
    const onSignInClick = () => {
        navigate(`/login`)
    }
    const onSignoutClick = () => {
        localStorage.removeItem("token");
        navigate(`/ws/${id}/home`)
    }


    return (
        <Container>
            {
                isMobile ?
                    // <div className={style.fixed}>
                    //     <HorizontalFlex gap={10}>
                    //         <FlexChild>
                    //             <Tab index={0} url={`/ws/${id}/main`} icon={"qrcode"} text={"결제"} />
                    //         </FlexChild>
                    //         <FlexChild>
                    //             <Tab index={1} url={"mypage"} icon={"userIcon"} text={"내 정보"} />
                    //         </FlexChild>
                    //         {/* <FlexChild>
                    //             <Tab index={2} url={"/"} icon={"home"} text={t("home")} />
                    //         </FlexChild>
                    //         <FlexChild>
                    //             <Tab index={3} url={"/mypage"} icon={"profile"} text={t("mypage")} />
                    //         </FlexChild>
                    //         <FlexChild>
                    //             <Tab index={4} url={"/shopping/cart"} icon={"cart"} text={t("cart")} />
                    //         </FlexChild> */}
                    //     </HorizontalFlex>
                    // </div>
                    <FlexChild width={"100%"} height={"40px"} overflow={"hidden"} backgroundColor={"white"}>
                        <VerticalFlex>
                            <FlexChild height={"1vh"}>
                            </FlexChild>
                            <FlexChild>
                                <Center textAlign={"left"}>
                                    {/* <P size={80} color={"white"}>하단배너</P> */}
                                    <P size={"min(2.5vw, 7px)"}>Copyright 2021.Puffu Corp. all rights reserved | 사업자등록번호 729-86-02229  |  대표: 임애향 | 대전광역시 서구 관저중로95번길 68, 1층 | 고객센터 070-4943-2597</P>
                                    {/* <P size={"min(2.5vw, 14px)"}>Copyright 2021.Puffu Corp. all rights reserved</P>
                                    <P size={"min(2.5vw, 14px)"}>사업자등록번호 729-86-02229  |  대표: 임애향</P>
                                    <P size={"min(2.5vw, 14px)"}>대전광역시 서구 관저중로95번길 68, 1층 | 고객센터 070-4943-2597</P> */}
                                </Center>
                            </FlexChild>
                            <FlexChild width={"25%"}>
                                <HorizontalFlex gap={20}>
                                    <FlexChild justifyContent={"flex-end"}>
                                        <P size={"min(1.5vw, 7px)"} cursor onClick={onTermsOfUseClick}>이용약관</P>
                                    </FlexChild>
                                    <FlexChild width={"max-content"}>
                                        <P size={"min(1.5vw, 7px)"}>|</P>
                                    </FlexChild>
                                    <FlexChild width={"max-content"}>
                                        <P size={"min(1.5vw, 7px)"} cursor onClick={onPrivacyPolicyClick}>개인정보정책</P>
                                    </FlexChild>
                                    <FlexChild width={"max-content"}>
                                        <P size={"min(1.5vw, 7px)"}>|</P>
                                    </FlexChild>
                                    <FlexChild justifyContent={"flex-start"} width={"max-content"}>
                                        <P size={"min(1.5vw, 7px)"} cursor onClick={onShippingPolicyClick}>배송정책</P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                        {/* <img src={banner} alt="" style={{ width: "100%", transform: "translateY(-30%)" }} /> */}
                    </FlexChild>
                    :
                    <FlexChild width={"100%"} height={"150px"} overflow={"hidden"} backgroundColor={"white"}>
                        <VerticalFlex>
                            <FlexChild height={"1vh"}>
                            </FlexChild>
                            <FlexChild>
                                <Center textAlign={"left"}>
                                    {/* <P size={80} color={"white"}>하단배너</P> */}
                                    <P>Copyright 2021.Puffu Corp. all rights reserved</P>
                                    <P>사업자등록번호 729-86-02229  |  대표: 임애향</P>
                                    <P>대전광역시 서구 관저중로95번길 68, 1층 | 고객센터 070-4943-2597</P>
                                </Center>
                            </FlexChild>
                            <FlexChild width={"50%"}>
                                <HorizontalFlex gap={20}>
                                    <FlexChild justifyContent={"flex-end"}>
                                        <P cursor onClick={onTermsOfUseClick}>이용약관</P>
                                    </FlexChild>
                                    <FlexChild width={"max-content"}>
                                        <P>|</P>
                                    </FlexChild>
                                    <FlexChild width={"max-content"}>
                                        <P cursor onClick={onPrivacyPolicyClick}>개인정보정책</P>
                                    </FlexChild>
                                    <FlexChild width={"max-content"}>
                                        <P>|</P>
                                    </FlexChild>
                                    <FlexChild justifyContent={"flex-start"} >
                                        <P cursor onClick={onShippingPolicyClick}>배송정책</P>
                                    </FlexChild>
                                    {/* <FlexChild width={"max-content"}>
                                        <P>|</P>
                                    </FlexChild> */}
                                    {/* <FlexChild justifyContent={"flex-start"}>
                                        {
                                            tokenPayload 
                                            ?
                                            <P cursor onClick={onSignoutClick}>로그아웃</P>
                                            :
                                            <P cursor onClick={onSignInClick}>로그인</P>
                                        }
                                        
                                    </FlexChild> */}
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                        {/* <img src={banner} alt="" style={{ width: "100%", transform: "translateY(-30%)" }} /> */}
                    </FlexChild>



                // <VerticalFlex>
                //     <FlexChild height={60} >
                //         <div className={style.desktopFooterWrap}>
                //             <Container maxWidth={1200}>
                //                 <HorizontalFlex gap={20} justifyContent={"center"}>
                //                     {
                //                         desktopFooterList.map((item, index) =>
                //                             <FlexChild key={index} width={150}>
                //                                 <Center>
                //                                     <div className={style.footerColumn}>
                //                                         <Link to={item.url}>
                //                                             {item.title}
                //                                         </Link>
                //                                     </div>
                //                                 </Center>
                //                             </FlexChild>
                //                         )
                //                     }
                //                 </HorizontalFlex>
                //             </Container>
                //         </div>
                //     </FlexChild>
                //     <FlexChild backgroundColor={"#eeeeee"}>
                //         <PaddingWrapper padding={20}>
                //             <Container maxWidth={1200}>
                //                 <HorizontalFlex>
                //                     <FlexChild>
                //                         <VerticalFlex padding={10}>
                //                             <FlexChild>
                //                                 <HorizontalFlex justifyContent={"flex-start"}>
                //                                     <P>{"주식회사 월드인터네셔널"} | </P>
                //                                     <P>(35372)대전광역시 서구 관저동 1114 5층</P>
                //                                 </HorizontalFlex>
                //                             </FlexChild>
                //                             <FlexChild>
                //                                 <HorizontalFlex justifyContent={"flex-start"}>
                //                                     <P>{t("businessNumber")} </P>
                //                                     <P>559-81-02488 | </P>
                //                                     <P>{t("ceo")} : 원태범</P>
                //                                 </HorizontalFlex>
                //                             </FlexChild>
                //                             <FlexChild>
                //                                 <HorizontalFlex justifyContent={"flex-start"}>
                //                                     <P>{t("serviceCenter")} :  </P>
                //                                     <P>070-4943-2597 | Fax : 042-489-8759 </P>
                //                                 </HorizontalFlex>
                //                             </FlexChild>
                //                             <FlexChild>
                //                                 <HorizontalFlex justifyContent={"flex-start"}>
                //                                     <P>{t("email")} :  </P>
                //                                     <P>worldvape@gmail.com </P>
                //                                 </HorizontalFlex>
                //                             </FlexChild>
                //                             <FlexChild>
                //                                 <HorizontalFlex justifyContent={"flex-start"}>
                //                                     <P>{t("mailOrderNumber")} :  </P>
                //                                     <P>2022-대전서구-0070 </P>
                //                                 </HorizontalFlex>
                //                             </FlexChild>
                //                         </VerticalFlex>
                //                     </FlexChild>
                //                     {/* <FlexChild>
                //                         <Logo4 fill={"#aaa"} width={200} />
                //                     </FlexChild> */}
                //                 </HorizontalFlex>
                //             </Container>
                //         </PaddingWrapper>
                //     </FlexChild>
                // </VerticalFlex>
            }
        </Container>
    );
}

export default Footer;



